import React from 'react';
import PropTypes from 'prop-types';
import RadioButtonGroup from 'bento-ordering/base/components/RadioButtonGroup';
import CheckBoxGroup from 'bento-ordering/base/components/CheckBoxGroup';

class VariantInputGroup extends React.Component {
  static propTypes = {
    fieldType: PropTypes.oneOf(['radiobutton', 'checkbox']),
    title: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    checked: PropTypes.bool,
    list: PropTypes.array.isRequired,
    value: PropTypes.any,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    selectionSatisfied: PropTypes.bool
  };

  static defaultProps = {
    value: {}
  };

  getInputComponent = () => {
    const { fieldType } = this.props;
    const COMPONENT_TYPE = {
      radiobutton: RadioButtonGroup,
      checkbox: CheckBoxGroup
    };

    return COMPONENT_TYPE[fieldType];
  };

  render() {
    const InputComponent = this.getInputComponent();
    const {
      title,
      onChange,
      checked,
      list,
      value,
      disabled,
      required,
      selectionSatisfied
    } = this.props;
    return (
      <InputComponent
        title={title}
        onChange={onChange}
        checked={checked}
        value={value}
        list={list}
        disabled={disabled}
        required={required}
        selectionSatisfied={selectionSatisfied}
        {...this.props}
      />
    );
  }
}

export default VariantInputGroup;
